// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KqG68","content":"styles_content__Aeln6","tableWrap":"styles_tableWrap__3bKQN"};